<template lang="pug">
    td.dt-checkbox
        label.md-check
            input.has-value(
                type="checkbox",
                :value="key",
                :checked="isSelected(key)"
                @click="toggleSelected(key)",
                :disabled="disabled"
            )
            i.indigo
</template>

<script>
import mixins from '../mixins';

export default {
    mixins: [mixins],

    props: {
        row: {
            type: Object,
            required: true,
        },
    },

    computed: {
        key() {
            return this.row[this.options.uniqueKey];
        },

        disabled() {
            return this.options.checkboxDisableCallback(this.row);
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/plugins/vuetable2-checkbox/components/checkbox.vue